module.exports = __webpack_public_path__ + "static/media/shape_P.afe16874.glb";